import CountryType from 'models/ActionBar/Country';
import useOnClickOutside from 'models/utils/useOnClickOutside';
import { useRef } from 'react';
import styles from './styles.module.scss';
import { redirectFavoriteProduct } from 'utils/constants';
import { cleanCookies } from 'utils/cookies';
import { getPreferredLanguage, updatePreferredLanguageCookie } from 'utils/preferredLanguage';

type Country = {
  onClick() : void
  country: CountryType
}

function Country(props : Country) : JSX.Element {
  const preferredLanguage = getPreferredLanguage();
  const dropdownRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(dropdownRef, props.onClick, ['react-select']);

  const onClick = async (): Promise<void> => {
    await cleanCookies();
    updatePreferredLanguageCookie(props.country.preferredLanguage);

    redirectFavoriteProduct();
    props.onClick();
  };

  const isCurrentLocale = () : boolean => {
    return preferredLanguage == props.country.preferredLanguage;
  };

  const getCurrentLocaleStyle = () : string => {
    return isCurrentLocale() ? styles['biobar-current-locale'] : '';
  };

  const currentDiv = () : JSX.Element => {
    if(isCurrentLocale())
      return <div id={styles['biobar-current']}></div>;

    return <></>;
  };

  return (
    <div
      ref={dropdownRef}
      className={`${styles['biobar-country']} ${getCurrentLocaleStyle()}`}
      onClick={onClick}>
      {currentDiv()}
      <img
        src={require(`../../../assets/${props.country.preferredLanguage}.png`)}
        className={styles['biobar-logo']}/>
      <p>{props.country.country}</p>
    </div>
  );
}

export default Country;